import { actionCreatorFactory } from "typescript-fsa";
import { licensedata, catalogModule } from "../typing/types";


const actionCreator = actionCreatorFactory("USERDETAILBOX");

 const resetData = actionCreator<{data:licensedata}>("UDB_RESETDATA");
 //const resetincmandData = actionCreator<{data:mandantendetails[]}>("UDB_RESETindmandDATA");
 //const resetnotmandData = actionCreator<{data:mandantendetails[]}>("UDB_RESETnotmandDATA");
 const SetUserDetail = actionCreator<{data:any, type:string}>("UDB_SETSTARTTIME");
 const CopyUserToNew = actionCreator<{data:any}>("UDB_SETSINFO");
 const SetToleranceDefault = actionCreator<{percent:number}>("UDB_SETTOLERANCEDEFAULT");
 const SetModuleCatalog = actionCreator<{modules:catalogModule[]}>("UDB_SETMODULECATALOG");
 
 export const UserDetailsActions = { resetData, SetUserDetail, CopyUserToNew, SetToleranceDefault, SetModuleCatalog}


